import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Advocates } from '../components/Advocates';
import { PracticeAreas } from '../components/PracticeAreas';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Clients } from '../components/Clients';
import { Contact } from '../components/Contact';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#2567A4] selection:text-white" data-id="element-227">
      <Navigation data-id="element-228" />
      <main data-id="element-229">
        <Hero data-id="element-230" />
        <About data-id="element-231" />
        <Advocates data-id="element-232" />
        <PracticeAreas data-id="element-233" />
        <WhyChooseUs data-id="element-234" />
        <Clients data-id="element-235" />
      </main>
      <Contact data-id="element-236" />
    </div>;
}